import { render, staticRenderFns } from "./CampoMascaraRegex.vue?vue&type=template&id=5b1d47d8"
import script from "./CampoMascaraRegex.vue?vue&type=script&lang=js"
export * from "./CampoMascaraRegex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports